<template>

  <!--  <div class="flex items-center p-4 bg-gray-800 text-white">-->
  <!--    <img src="../src/assets/img/logo.png" alt="هتل تبرک" class="w-8">-->
  <!--    <span class="mr-2">{{ pageTitle}}</span>-->
  <!--  </div>-->
  <div class="flex flex-col absolute w-full top-2 gap-y-5 z-20">
    <transition-group name="slide">
      <VNotification
          v-for="(notification, index) in notifications"
          :key="notification"
          :notification="notification"
          @click="notifications.splice(index, 1)"/>
    </transition-group>
  </div>

  <LoadingProgressBar/>

  <router-view/>

  <div class="h-20"></div>

  <BottomNavigation/>

  <CartBottomSheet v-model:visible="this.$cart.value"/>

  <InfoModal />
</template>

<script>
import LoadingProgressBar from "@/components/General/LoadingProgressBar";
import BottomNavigation from "@/components/BottomNavigation";
import CartBottomSheet from "@/components/CartBottomSheet";
import {getMessaging, onMessage} from "firebase/messaging";
import firebaseApp from "@/utils/firebase";
import VNotification from "@/components/General/VNotification";
import InfoModal from "@/components/Modal/InfoModal.vue";

export default {
  components: {InfoModal, VNotification, CartBottomSheet, BottomNavigation, LoadingProgressBar},
  data() {
    return {
      pageTitle: this.$pageTitle,
      notifications: []
    }
  },
  created() {
    this.$pageTitle.value = 'هتل تبرک'
    this.$store.dispatch('getLanguages')

    const messaging = getMessaging(firebaseApp);
    onMessage(messaging, (payload) => {
      this.notifications.push(payload.notification)
      let audio = new Audio(require('./assets/notification.wav'));
      audio.play();
    });
  },
}
</script>

<style>
@font-face {
  font-family: 'iransans';
  src: url('@/assets/font/iran_sans.ttf');
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

*::-webkit-scrollbar {
  display: none;
}

html, body {
  font-family: 'iransans' !important;
  direction: rtl;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  @apply bg-gray-100
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s ease-in-out;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}

.introjs-tooltiptext {
  font-family: 'iransans';
  @apply text-sm
}
</style>
